// components/Publication/RedirectPublicationById.jsx
import { useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { publicationdetail } from "../../services/publicationService";
import { buildPublicationPath } from "../../utils/slugify";
import { AppContext } from "../../services/AuthContext";

export default function RedirectPublicationById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await publicationdetail(id, auth?.token);
        if (!alive) return;
        if (res?.status === "OK") {
          // publicationdetail response shape: assume res.data contains fields with title info
          // publicationdetail returns data.elasticjson
          const pub = res.data?.elasticjson || res.data;
          // title extraction: try several attribute locations used in CourseDetails
          const title = pub?.publicationtypeInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0]
            || pub?.templateInfo?.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0]
            || pub?.title || "";
          navigate(buildPublicationPath({ title, id }), {
            replace: true,
            state: { preFetchedData: res.data.elasticjson } // Veriyi yanına koy
          });
        } else {
          navigate("/home", { replace: true });
        }
      } catch (e) {
        navigate("/home", { replace: true });
      }
    })();
    return () => { alive = false; };
  }, [id, navigate]);

  return null;
}
